import { render, staticRenderFns } from "./instAmountSelector.vue?vue&type=template&id=b2197f52&scoped=true"
import script from "./instAmountSelector.vue?vue&type=script&lang=js"
export * from "./instAmountSelector.vue?vue&type=script&lang=js"
import style0 from "./instAmountSelector.vue?vue&type=style&index=0&id=b2197f52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2197f52",
  null
  
)

export default component.exports